import { ReactRenderer } from '@tiptap/react';
import { SlashMenuProps } from './slashCommand.types';

export const positionMenu = (
  component: ReactRenderer<HTMLUListElement, SlashMenuProps>,
  clientRect?: (() => DOMRect | null) | null
) => {
  if (!clientRect) return;

  const rect = clientRect();

  if (!rect) return;

  if (component) {
    const element = component.element as HTMLUListElement;
    element.style.position = 'absolute';
    element.style.zIndex = '1000';
    element.style.left = `${rect.left + window.scrollX}px`;
    element.style.top = `${rect.bottom + window.scrollY}px`;
  }
};

export const cleanupMenu = (
  component: ReactRenderer<HTMLUListElement, SlashMenuProps>
) => {
  component.element.remove();
  component.destroy();
};
